import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import cx from "classnames";
import "styles/search-filter.css";

const ENUMS = [
    {
        label: "Pass",
        value: 1
    },
    {
        label: "Review",
        value: 3
    },
    {
        label: "Fail",
        value: 2
    }
];

const Component = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    filterOverrideClassName
}) => {
    let input = null;
    // let ignoreBlur = false;
    return (
        <div
            className={cx("custom-filter-dropdown", filterOverrideClassName)}
            onFocus={e => e.stopPropagation()}
        >
            <Select
                ref={node => (input = node)}
                placeholder="Search name"
                value={selectedKeys[0]}
                onChange={e => {
                    // e.stopPropagation();
                    setSelectedKeys(e ? [e] : []);
                }}
                onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    input.focus();
                }}
                onPressEnter={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    confirm();
                }}
                onBlur={confirm}
            >
                {ENUMS.map(_ => (
                    <Select.Option key={_.value} value={_.value}>
                        {_.label}
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
};
Component.displayName = "TableSearchFilterDropdown";
Component.propTypes = {
    setSelectedKeys: PropTypes.func,
    confirm: PropTypes.func,
    clearFilters: PropTypes.func,
    selectedKeys: PropTypes.any,
    filterOverrideClassName: PropTypes.string
};
export default Component;
